// constants.ts — app-wide shared constants

export const CALENDLY_URL = "https://calendly.com/triptic_ai/free-15-min-intro-call";
